const ApiURL = "https://prod.heysteady.com/api"


export {ApiURL}